export const parseToNumber = (value: string | number | null | undefined): number | null => {
    if (value === null || value === undefined) {
        return null;
    }

    const parsed = typeof value === "number" ? value : Number(value);

    return Number.isNaN(parsed) ? null : parsed;
};
